import ContentHeading from "@/components/content-heading";
import PrivacyText from "../privacy-text";
import { useTranslation, Trans } from "react-i18next";

import {
  wrapper,
  usability,
  subheading,
  description,
  link,
  privacyText,
} from "./style/get-a-quote";

import GetInTouchForm from "@/components/forms/get-in-touch";
import { RequestDemoForm } from "@/components/forms";

const GetAQuote: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section
      className={wrapper}
      title={t(`pricing.form.seo.title`)}
      aria-label={t(`pricing.form.seo.aria-label`)}
    >
      <div className={usability}>
        <ContentHeading
          h="p"
          className="justify-center"
          backdropPosition="left-4"
          fontSize="mobile:text-2xl tablet:text-4xl"
          background="bg-primary bg-opacity-40"
        >
          {t("pricing.form.heading")}
        </ContentHeading>
        <RequestDemoForm
          formClassName="GA4-LeadConversion"
          formId="pricing-get-in-touch-form"
        />
      </div>
    </section>
  );
};

export default GetAQuote;
